unit TemperatureListType;

interface

uses
  SysUtils,
  WEBLib.StdCtrls,
  TemperatureType;

type
  TTemperatureListType = array of TTemperatureType;

  procedure FillComboBoxOnMaxTemperature(const TemperatureList: TTemperatureListType; const Single_MaxTemperature: Single; var ComboBox_Temperature: TComboBox);

implementation

procedure FillComboBoxOnMaxTemperature(const TemperatureList: TTemperatureListType; const Single_MaxTemperature: Single; var ComboBox_Temperature: TComboBox);
var
  Temperature: TTemperatureType;
  Byte_Item: Byte;
begin
  ComboBox_Temperature.Items.Clear;

  for Byte_Item := 0 to Length(TemperatureList) - 1 do
    if TemperatureList[Byte_Item].Value <= Single_MaxTemperature then
    begin
      Temperature := TemperatureList[Byte_Item];

      ComboBox_Temperature.Items.AddObject(FloatToStr(Temperature.Value), Temperature);
    end;
end;

end.
